export const ADD_TODO = 'ADD_TODO';
export const TOGGLE_TODO = 'TOGGLE_TODO';
export const DELETE_TODO = 'DELETE_TODO';
export const SET_FILTER = 'SET_FILTER';
export const EDIT_TODO = 'EDIT_TODO';
export const ADD_TEXT = 'ADD_TEXT';
